module.exports = __webpack_public_path__ + "img/payless1.0018cba1.gif";